module.exports = __webpack_public_path__ + "media/brand/yoojo-logo@white-8d2c0269.svg";